import React, { memo } from 'react';
import { PlusWelcomeDialog } from '@browsing/plus';

import {
    HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME,
    useIsPlatformJourney,
} from '@client/components/mylounge/platform-journeys';

const WelcomeDialog = () => {
    const isPlatformJourney = useIsPlatformJourney();

    return (
        <PlusWelcomeDialog
            isPlatformJourney={isPlatformJourney}
            platformJourneyDismissCookie={HIDE_NEWSLETTER_SUBSCRIPTION_DIALOG_COOKIE_NAME}
        />
    );
};

export default memo(WelcomeDialog);
